/** Show the route loader only after navigation/init exceeds this threshold. */
const ROUTE_LOADER_DELAY_MS = 300;

/** Iframe opens on these routes before cart handoff — no per-navigation loader. */
export const IFRAME_BOOTSTRAP_ROUTE_NAMES = new Set([
  "HostedPage",
  "SelectCurrency",
]);

let iframeCartLoadingActive = false;
let pendingCount = 0;
let delayTimer = null;
let visible = false;
const listeners = new Set();

function notify() {
  listeners.forEach((listener) => {
    listener(visible);
  });
}

function show() {
  if (visible) {
    return;
  }
  visible = true;
  notify();
}

function hide() {
  if (!visible) {
    return;
  }
  visible = false;
  notify();
}

function scheduleShow() {
  if (delayTimer || visible) {
    return;
  }
  delayTimer = setTimeout(() => {
    delayTimer = null;
    if (pendingCount > 0) {
      show();
    }
  }, ROUTE_LOADER_DELAY_MS);
}

function cancelScheduledShow() {
  if (delayTimer) {
    clearTimeout(delayTimer);
    delayTimer = null;
  }
}

export function subscribeRouteLoader(listener) {
  listeners.add(listener);
  listener(visible);
  return () => listeners.delete(listener);
}

export function isRouteLoadingPending() {
  return pendingCount > 0;
}

export function isIframeCartLoadingActive() {
  return iframeCartLoadingActive;
}

/** One loader for hosted-page fetch + cart init + handoff navigation. */
export function beginIframeCartLoading() {
  if (iframeCartLoadingActive) {
    return;
  }
  iframeCartLoadingActive = true;
  startRouteLoading();
}

export function endIframeCartLoading() {
  if (!iframeCartLoadingActive) {
    return;
  }
  iframeCartLoadingActive = false;
  resetRouteLoading();
}

export function shouldSkipRouteLoaderForNavigation(to, from) {
  if (iframeCartLoadingActive) {
    return true;
  }
  if (IFRAME_BOOTSTRAP_ROUTE_NAMES.has(to.name)) {
    return true;
  }
  if (
    IFRAME_BOOTSTRAP_ROUTE_NAMES.has(from.name) &&
    (to.name === "Sign in" || to.name === "Welcome" || to.name === "Payment")
  ) {
    return true;
  }
  return false;
}

export function startRouteLoading() {
  pendingCount += 1;
  if (pendingCount === 1) {
    scheduleShow();
  }
}

export function finishRouteLoading() {
  pendingCount = Math.max(0, pendingCount - 1);
  if (pendingCount === 0) {
    cancelScheduledShow();
    hide();
  }
}

export function resetRouteLoading() {
  pendingCount = 0;
  cancelScheduledShow();
  hide();
}
